

<div *ngIf="this.block.data.style" class="tile-wrapper tile-wrapper--{{block.data.style || 'style1'}}">
    <div class="tile-container">
        <div *ngFor="let block of block.content; trackBy: trackByFn; let isFirst = first;" [ngClass]="{'tile-item--has-image': block.data.image, 'tile-item--no-image': !block.data.image}"
                [ngStyle]="{backgroundImage: block.data.image && isStyle2 ? 'url(' + block.data.image + ')' : null}"
                class="tile-item">
            <div *ngIf="this.block.data.benefitTag" class="tile-tag">
                <div [ngStyle]="{'background-color':block.data.tagcolour}" class="tile-circle"></div>
                {{block.data.benefitTag}}
            </div>
            <div *ngIf="(block.data.image && isStyle4) || (block.data.image && isStyle6)" [ngStyle]="{backgroundImage: 'url(' + block.data.image + ')'}" class="tile-caption__image">
            </div>
            <div class="tile-caption">
                <div class="tile-caption__content">
                    <h3 *ngIf="isStyle5 && isFirst" class="tile-caption__header">
                        <abbr title="Frequently Asked Question">FAQ</abbr>
                    </h3>
                    <span [outerHTML]="block.data.content"></span>
                    <a *ngIf="block.data.buttonText" class="btn btn-primary tile-caption__button" href="{{block.data.link}}" target="{{block.data.target}}">{{block.data.buttonText}}</a>
                    <p *ngIf="block.data.groupId" class="tile-caption__group-id">{{block.data.groupId}}</p>
                </div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="!this.block.data.style" [innerHTML]="this.block.content[0].data.content" class="tile-no-style"></div>
